import Vuex from 'vuex';
import CacheStore from 'services/utils/cacheStore';
import SingletonService from 'services/utils/singletonService';
import http from 'services/utils/http';

const api = 'userData';

const UserDataStore = {
    state: {
        userData: null
    },
    mutations: {
        setUserData: (state, userData) => {
            state.userData = userData;
        }
    },
    getters: {
        userData: (state) => state.userData
    }
};

class UserData {
    requestInProgressPromise = null;

    cache = CacheStore.getStore(api);

    userDataStore = new Vuex.Store({
        ...UserDataStore,
        namespaced: true
    });

    userDataResolve = null;

    userDataReject = null;

    userDataPromise = null;

    constructor() {
        if (!window.sspStores) {
            window.sspStores = {};
        }
        window.sspStores.userDataStore = this.userDataStore;
    }

    clearUserData() {
        this.userDataStore.commit('setUserData', null);
        this.requestInProgressPromise = null;
        this.userDataPromise = null;
        this.userDataResolve = null;
        this.userDataReject = null;
        this.cache.commit({
            type: 'clearCache',
            api
        });
        window.SSPUserData = { fetchUserDataPromise: null };
    }

    async fetchUserData() {
        this.userDataPromise = new Promise((resolve, reject) => {
            this.userDataResolve = resolve;
            this.userDataReject = reject;
        });

        if (!window.SSPUserData || !window.SSPUserData.fetchUserDataPromise) {
            window.SSPUserData = {};
        }
        window.SSPUserData.fetchUserDataPromise = this.userDataPromise;

        const apiUrl = '/partners/utils/userData';
        try {
            this.requestInProgressPromise = true;
            const res = await http.get(apiUrl);
            this.requestInProgressPromise = false;
            if (res) {
                this.userDataStore.commit('setUserData', res.data.userData);
                this.requestInProgressPromise = null;
                this.cache.commit({
                    type: 'setCache',
                    api,
                    req: '',
                    data: res.data.userData
                });
                if (this.userDataResolve) {
                    this.userDataResolve(res.data.userData);
                }
            } else if (this.userDataReject) {
                this.userDataReject();
            }
        } catch (e) {
            if (this.userDataReject) {
                this.userDataReject(e);
            } else {
                throw e;
            }
        }
    }

    getPromiseFromAngular() {
        this.userDataPromise = new Promise((resolve, reject) => {
            this.userDataResolve = resolve;
            this.userDataReject = reject;
        });

        window.SSPUserData.fetchUserDataPromise.then((res) => {
            if (this.userDataResolve) {
                this.userDataResolve(res);
            }
        });
    }

    async getUserData(refresh = false) {
        if (!this.requestInProgressPromise && !refresh
            && !this.userDataStore.getters.userData
            && window.SSPUserData && window.SSPUserData.fetchUserDataPromise) {
            this.getPromiseFromAngular();
        } else if (refresh || !this.userDataPromise) {
            await this.fetchUserData(refresh);
        }
        return this.userDataPromise;
    }

    subscribeUserDataChanges(func) {
        this.userDataStore.subscribe(func);
    }

    userDataLoaded() {
        return !!this.userDataStore.getters.userData;
    }
}

const singletonService = new SingletonService(api);
if (!singletonService.isInitialized()) {
    singletonService.setService(new UserData());
}
if (!window.SSPServices) {
    window.SSPServices = {};
}
window.SSPServices.userDataService = singletonService.getService();
export default singletonService.getService();
